var $fc98374bce6a8f49$exports = {};
$fc98374bce6a8f49$exports = {
    "decrease": (args)=>`V\xe4henn\xe4 ${args.fieldLabel}`,
    "increase": (args)=>`Lis\xe4\xe4 ${args.fieldLabel}`,
    "numberField": `Numerokentt\xe4`
};


export {$fc98374bce6a8f49$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
